export const formCloser = formFunction => {
  return () => formFunction(false);
}